import React from 'react';
import { useReveal } from '../lib/useReveal';
const ITEMS = ['Querés aprender astrología desde cero', 'Te interesa el autoconocimiento', 'Buscás comprender tu carta natal', 'Querés interpretar cartas de familiares o amigos', 'Valorás estudiar a tu ritmo', 'Buscás una formación clara y organizada', 'Te interesa el desarrollo personal y espiritual'];
export function AudienceSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#0a0e1f] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-16">
      <div className="container mx-auto max-w-3xl" data-id="element-17">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-18">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6] text-center mb-6" data-id="element-19">
            Esta formación es para vos si…
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-20">
            {ITEMS.map((item, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1f3d] border border-[#d4af37]/15 rounded-xl p-4 shadow-sm" data-id="element-21">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 flex items-center justify-center mt-0.5" data-id="element-22">
                  <span className="text-[#d4af37] text-sm font-bold" data-id="element-23">✓</span>
                </div>
                <p className="text-[#cbd0e0] text-sm sm:text-base font-medium leading-snug" data-id="element-24">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}